import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderSlider';
import { AppState } from '../../../../../types/store';
import { getSelectedFolderId } from '../../../../selectors/gallectionSection';
import { getOrderedNonEmptyRootFolders } from '../../../../selectors/folders';

export type StateProps = Pick<Props, 'folders' | 'selectedFolderId'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folders: getOrderedNonEmptyRootFolders(state),
  selectedFolderId: getSelectedFolderId(state),
});

export default connect(mapStateToProps);
